<template>
    <button v-bind="$attrs" class="w-full bg-white font-bold text-a-blue-2140a6 text-18 text-center rounded-sm border border-a-blue-2140a6"
        :class="[btnClass]">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: 'WhiteButton',
    props: {
        customClass: { type: String, default: null },
    },
    computed: {
        btnClass: function() {
            if (this.customClass != null) {
                return this.customClass;
            }
            return 'p-3.5';
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
